export const environment = {
  production: true,
  domain: 'https://veteran.rvts.no',
  base: '/api',
  wp: '/wp/v2',
};
